export const EXCLUDE_FIELD_PROPERTIES = [
  'noHeader.status',
  'noHeader.visibility',
  'Labeling',
  'ProductAnalytics',
];

export const OVERLAY = 'overlay';
